import React from "react";
import useEscapeKey from "./useEscapeKey";

// 確認ダイアログ（誤操作防止）。背景クリック / Esc / やめる で閉じる共通部品。
// open=表示可否, ariaLabel=aria-label, title=見出し, children=本文,
// onClose=閉じる, onConfirm=確定, confirmLabel/confirmClass/confirmDisabled=確定ボタン,
// cancelLabel=左ボタン文言（既定「やめる」）。Esc は open の間だけ有効。
export default function ConfirmDialog({
  open,
  ariaLabel,
  title,
  children,
  onClose,
  onConfirm,
  confirmLabel = "確定する",
  confirmClass = "mp-danger",
  confirmDisabled = false,
  cancelLabel = "やめる",
}) {
  useEscapeKey(onClose, open);
  if (!open) return null;
  return (
    <div className="mp-modal-back" onClick={onClose}>
      <div className="mp-modal mp-confirm" role="dialog" aria-modal="true" aria-label={ariaLabel} onClick={(e) => e.stopPropagation()}>
        <div className="mp-confirm-body">
          <div className="mp-confirm-title">{title}</div>
          <div className="mp-confirm-text">{children}</div>
        </div>
        <div className="mp-confirm-actions">
          <button className="mp-btn mp-ghost" onClick={onClose}>{cancelLabel}</button>
          <button className={`mp-btn ${confirmClass}`} disabled={confirmDisabled} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
